
<!--
  Copyright (c) 2022 by Leyton Group - All Rights Reserved.
  This source code, and resulting software, is the confidential and proprietary information
  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  and shall use it only in accordance with the terms and conditions of any and all license
  agreements you have entered into with The Company.
  -->

<template>
  <b-modal
      :id="id"
      modal-class="giga-modal"
      dialog-class="modal-lg"
      content-class="text-center pb-2"
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      hide-footer
      lazy
  >

    <div class="gigawhat-modal">
      <div class="modal-heading">
        <h2 class="modal-title" v-text="title"></h2>
      </div>
      <fieldset v-if="getCurrentStep === 1">
        <div class="input-row">
          <label class="input-label">Nom du rôle</label>
          <div class="input-field">
            <b-form-input
                id="name"
                type="text"
                pill
                class="input-text"
                :disabled="isReadOnly"
                v-model="$v.roleForm.name.$model"
            ></b-form-input>
            <div v-if="this.next && !$v.roleForm.name.required">
              <small class="form-text text-danger">
                {{$t('required_field')}}
              </small>
            </div>
          </div>

        </div>
        <div class="input-row">
          <label class="input-label">Description du rôle</label>
          <div class="input-field">
            <b-form-textarea
                v-model="$v.roleForm.description.$model"
                class="input-textarea"
                :disabled="isReadOnly"
                name="description"
                id="description"
            >
            </b-form-textarea>
            <div v-if="this.next && !$v.roleForm.description.required">
              <small class="form-text text-danger">
                {{$t('required_field')}}
              </small>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="isReadOnly"
                  class="modal-cancel_button"
                  type="button"
                  @click="$emit('closeClick')"
          >
            Fermer
          </button>
          <button v-else class="modal-cancel_button" type="button" @click="$emit('closeClick')">Annuler</button>
          <button class="modal-submit_button" type="button" @click.prevent="nextStep(2)">Next</button>
        </div>
      </fieldset>
      <fieldset v-if="getCurrentStep === 2">
        <div class="input-row" v-for="(permission, i) in permissions" :key="permission.id">
          <div class="input-field">
            <div class="permission-field" :class="{'active-permissions_list' : i === clickedPermission}">
              <div class="permission-label">
                <div class="checkbox-field">
                  <b-form-checkbox
                      pill
                      class="input-checkbox mt-4"
                      v-model="permission.isSelected"
                      :disabled="isReadOnly"
                      :id="'check'+i"
                  ></b-form-checkbox>
                  <span></span>
<!--                  <div class="custom-checkbox"></div>-->
                </div>
                <label :for="'check'+i">{{$t(permission.name)}}</label>
              </div>
            </div>
          </div>
        </div>
        <div v-if="this.validateClicked && !$v.roleForm.permissions.required">
          <small class="form-text text-danger">
            {{$t('required_select_permission')}}
          </small>
        </div>
        <div class="modal-footer">
          <button class="modal-cancel_button" type="button" @click.prevent="prevStep(1)">Retour</button>
          <button v-if="isReadOnly"
                  class="modal-submit_button"
                  type="button"
                  @click="$emit('closeClick')"
          >
            Fermer
          </button>
          <button v-else-if="loader" class="modal-submit_button" type="submit">
            <b-spinner variant="light" small
                       class="align-middle"
                       v-if="loader">
            </b-spinner>
          </button>
          <button v-else class="modal-submit_button" type="submit" @click="$emit('confirmClick')">
            Valider
          </button>
        </div>
      </fieldset>
    </div>
  </b-modal>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "RoleModal",
  props: ['id','title', 'isReadOnly' ,'roleForm', 'clickedPermission', 'permissions', 'validateClicked', 'nextClicked' ,'loader'],
  data() {
    return {
      next: this.nextClicked,
    }
  },
  validations: {
    roleForm: {
      name: {
        required
      },
      description: {
        required
      },
      permissions: {
        required
      }
    }
  },
  methods: {
    ...mapActions('account', ['changeCurrentStepAction']),
    nextStep: function(next){
      this.next = true
      if (this.roleForm.name !== '' && this.roleForm.description !== '') {
        this.changeCurrentStepAction(next)
        this.next = false
      }

    },
    prevStep: function(prev){
      this.changeCurrentStepAction(prev)
    },
  },
  computed: {
    ...mapGetters('account', {getCurrentStep: 'getCurrentStep'}),
  }
}
</script>

<style scoped>

</style>
